import React from 'react';
import { StyledTableContent, StyledTableHeader } from '../../table/StyledTable';
import { MatchActualCheckDepositRow } from './MatchActualCheckDepositRow';
import { IPageData } from 'types/rest/IPageData';
import { Grid, PageLoading } from 'ui-toolkit';
import { IEscrowActualIncomingCheckData } from 'types/accounting/data/IEscrowActualIncomingCheckData';
import { IEscrowActualIncomingCheckQuery } from 'types/accounting/query/IEscrowActualIncomingCheckQuery';
import { MatchActualCheckDepositSearchBar } from './MatchActualCheckDepositSearchBar';
import { StyledTableRow, StyledTableHeaderValue } from './MatchedActualStyles';
import { Pager } from 'ui-toolkit/components/DataGrid/tabbedTable/BottomPager';

interface IMatchActualCheckDepositTableProps {
  data: IPageData<IEscrowActualIncomingCheckData>;
  isQueryFetching: boolean;
  query: IEscrowActualIncomingCheckQuery;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
  setQuery: (query: IEscrowActualIncomingCheckQuery) => void;
}

export const MatchActualCheckDepositTable: React.FC<IMatchActualCheckDepositTableProps> = ({
  query,
  data,
  isQueryFetching,
  selectedId,
  setSelectedId,
  setQuery,
}) => {
  const columns = ['Completed At Date', 'Check Identifier', 'Check Detail', 'Received', 'Unmatched', 'Selected'];

  const onPageChange = (newPage: number) => {
    setQuery({ ...query, pageNumber: newPage });
  };
  const onPageSizeChange = (newPageSize: number) => {
    setQuery({ ...query, pageSize: newPageSize });
  };

  return (
    <>
      <Grid rowGap={'baseUnit'}>
        <MatchActualCheckDepositSearchBar setQuery={setQuery} query={query} />
        <StyledTableHeader>
          <StyledTableRow columnsLength={columns.length}>
            {columns.map((t) => (
              <StyledTableHeaderValue key={t}>{t}</StyledTableHeaderValue>
            ))}
          </StyledTableRow>
        </StyledTableHeader>
        <PageLoading isLoading={isQueryFetching}>
          <StyledTableContent className={'pb-4'}>
            {data?.content?.map((item) => (
              <MatchActualCheckDepositRow
                checkDeposit={item}
                key={item.id}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
          </StyledTableContent>
          <Pager
            total={data.totalElements}
            page={data.pageNumber}
            pageSize={data.pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </PageLoading>
      </Grid>
    </>
  );
};
